(ns manage.product-selector-ocp.view
  (:require ["@mui/material/Accordion$default" :as Accordion]
            ["@mui/material/AccordionDetails$default" :as AccordionDetails]
            ["@mui/material/AccordionSummary$default" :as AccordionSummary]
            ["@mui/material/Button$default" :as Button]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Tab$default" :as Tab]
            ["@mui/material/Tabs$default" :as Tabs]
            ["@mui/material/Typography$default" :as Typography]
            ["react-hook-form" :as rhf]
            ["src/svg/wpp/content/cart.svg$default" :as Cart]
            [cljs-bean.core :refer [->clj ->js]]
            [common.ocp.view :refer [defocp ocp]]
            [common.patterns.loading-view :refer [loading-view]]
            [common.queries :refer [use-mutation use-query]]
            [common.resource.query.product-selector :as product-selector.q]
            [manage.product-selector-page.hooks :as hooks]
            [manage.product-selector-page.sections.combination-strategy :as combination-strategy]
            [manage.product-selector-page.sections.conditions :as conditions]
            [manage.product-selector-page.sections.details :as details]
            [manage.product-selector-page.sections.exclusion :as exclusion]
            [manage.product-selector-page.sections.key-matching :as key-matching]
            [manage.product-selector-page.sections.prioritisation :as prioritisation]
            [manage.product-selector-page.sections.product-selectors :as product-selectors]
            [manage.product-selector-page.sections.required-fields :as required-fields]
            [manage.product-selector-page.sections.sorting :as sorting]
            [manage.product-selector-result-table.view :as result-table]
            [mate.core :as mc]
            [re-frame.core :as rf]
            [reitit.frontend.easy :as r.easy]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defn sections [type]
  (let [default-sections [{:key :details
                           :label "Details"
                           :view details/read}]
        type-sections (case type
                        "single" [{:key :conditions
                                   :label "Conditions"
                                   :view conditions/read}
                                  {:key :sorting
                                   :label "Sorting"
                                   :view sorting/read}
                                  {:key :key-matching
                                   :label "Key matching"
                                   :view key-matching/read}
                                  {:key :required-fields
                                   :label "Required fields"
                                   :view required-fields/read}
                                  {:key :prioritisation
                                   :label "Product prioritisation"
                                   :view prioritisation/read}
                                  {:key :exclusion
                                   :label "Product exclusion"
                                   :view exclusion/read}]

                        "combined" [{:key :product-selectors
                                     :label "Product selectors"
                                     :view product-selectors/read}
                                    {:key :settings
                                     :label "Settings"
                                     :view combination-strategy/read}])]
    (concat default-sections type-sections)))

(defui details-tab [{:keys [product-selector]}]
  (let [sections (sections (:type product-selector))]
    ($ Stack {:gap 1.5}
       (for [section sections]
         ($ Accordion
            {:key (:key section)
             :defaultExpanded true}
            ($ AccordionSummary
               ($ Typography {:sx (fn [^js theme]
                                    #js {:fontFamily (.. theme -typography -fontFamily)
                                         :fontSize "lg"
                                         :fontWeight 600})}
                  (:label section)))
            ($ AccordionDetails {:sx #js {:px 3.5}}
               ($ (:view section))))))))

(def tabs
  [{:id :details
    :label "Details"
    :view details-tab}
   {:id :products
    :label "Products"
    :view result-table/product-selector-result-datagrid}])

(defui footer [{:keys [product-selector]}]
  (let [{:keys [advertiser-id] :as url-context} (use-subscribe [:url-context])
        {delete-product-selector :mutate} (use-mutation (product-selector.q/delete-product-selector-mutation
                                                         {:advertiser-id advertiser-id}))

        on-delete (uix/use-callback (fn []
                                      (delete-product-selector
                                       {:id (:id product-selector)}
                                       #js {:onSuccess #(rf/dispatch [:ocp/close])}))
                                    [delete-product-selector product-selector])]
    ($ Stack
       {:direction "row"
        :justifyContent "space-between"}
       ($ Button
          {:variant "outlined"
           :onClick #(rf/dispatch [:modal/open {:id :product-selector/confirm-delete
                                                :props {:on-confirm on-delete}}])
           :color "error"}
          "Delete")
       ($ Button
          {:variant "contained"
           :onClick #(rf/dispatch [:ocp/close])
           :href (r.easy/href :advertiser/product-selector
                              url-context
                              {:product-selector-id (:id product-selector)})}
          "View full screen"))))

(defui product-selector-ocp* [{:keys [product-selector opened-from-preview-page?
                                      allow-product-overrides? product-overrides set-products-fn]}]
  (let [[active-tab set-active-tab] (uix/use-state :details)
        tabs* (uix/use-memo (fn []
                              (mc/index-by :id tabs))
                            [tabs])

        ;; We're using the form hook here as some components down the line need the form context.
        {{:keys [getValues] :as form-control} :form-control} (hooks/use-product-selector-form product-selector)]
    ($ rhf/FormProvider (->js form-control)
       ($ ocp
          {:title "Product selector"
           :footer (when (not opened-from-preview-page?)
                     ($ footer {:product-selector product-selector}))}
          ($ Stack {:direction "row"
                    :gap 0.5
                    :alignItems "center"}
             ($ Icon ($ Cart))
             ($ Typography {:fontWeight "500"} (-> product-selector :name)))

          ($ Tabs
             {:value active-tab
              :onChange (fn [_ tab]
                          (set-active-tab (keyword tab)))
              :sx #js {:minHeight "36px"}}
             (for [[key {:keys [label]}] tabs*]
               ($ Tab
                  {:key key
                   :value key
                   :label (if (and (= label "Products") opened-from-preview-page?) "Products in preview" label)
                   :disableRipple true
                   :sx #js {:px 1.5
                            :py 0.75
                            :minWidth "unset"
                            :minHeight "unset"}})))
          ($ (get-in tabs* [active-tab :view])
             {:product-selector (->clj (getValues))
              :allow-product-overrides? allow-product-overrides?
              :product-overrides product-overrides
              :set-products-fn set-products-fn})))))

(defocp product-selector-ocp :product-selector/crud
  {:width "min(max(55%, 760px), 100%)"}
  [{:keys [product-selector-id opened-from-preview-page? allow-product-overrides? product-overrides set-products-fn]}]
  (let [{:keys [advertiser-id]} (use-subscribe [:url-context])

        {product-selector :data isSuccess :isSuccess}
        (use-query (product-selector.q/product-selector-query
                    {:advertiser-id advertiser-id
                     :product-selector-id product-selector-id}))]
    (if isSuccess
      ($ product-selector-ocp*
         {:product-selector product-selector
          :opened-from-preview-page? opened-from-preview-page?
          :allow-product-overrides? allow-product-overrides?
          :product-overrides product-overrides
          :set-products-fn set-products-fn})
      ($ loading-view))))
